import { parseISO } from 'date-fns';
import { FunctionComponent, memo, useCallback, useContext, useMemo } from 'react';
import { EventDetailsModalContext, EventDetailsTab } from '../../../../context';
import { Event } from '../../../../services';
import { ImageSingle } from '../../ImageGallery';
import { EventDateBadge } from './EventDateBadge';
import { EventItemBody } from './EventItemBody';
import { EventItemHeader } from './EventItemHeader';

import classNames from 'classnames';
import classes from './EventItemContent.module.scss';

interface EventItemContentProps {
  event: Event;
  showDescription?: boolean;
  showViewLink?: boolean;
  noPadding?: boolean;
  onDeleteSuccess?: () => void;
  onSelectTab?: (tab: EventDetailsTab) => void;
}

export const EventItemContent: FunctionComponent<EventItemContentProps> = memo(
  ({
    event,
    showDescription = false,
    showViewLink = false,
    noPadding,
    onDeleteSuccess,
    onSelectTab,
  }) => {
    const { setEventDetailsModalData } = useContext(EventDetailsModalContext);

    const { id: eventId, startAt, image } = event;

    const startDate = useMemo(() => parseISO(startAt), [startAt]);

    const openEventDetails = useCallback(() => {
      setEventDetailsModalData({ eventId });
    }, [setEventDetailsModalData, eventId]);

    if (!image?.url) {
      return (
        <div
          className={classNames(classes['event-item-content__body'], {
            [classes['event-item-content__body--no-padding']]: noPadding,
          })}
        >
          <EventItemHeader
            event={event}
            showDateBadge
            {...(showViewLink && { onClick: openEventDetails })}
          />
          <EventItemBody
            event={event}
            showDescription={showDescription}
            showViewLink={showViewLink}
            onDeleteSuccess={onDeleteSuccess}
            onSelectTab={onSelectTab}
          />
        </div>
      );
    }

    return (
      <>
        <div className={classes['event-item-content__image']}>
          <ImageSingle item={{ image }} modalPreviewOnClick />
          <EventDateBadge date={startDate} className={classes['event-item-content__badge']} />
        </div>
        <div
          className={classNames(classes['event-item-content__body'], {
            [classes['event-item-content__body--no-padding']]: noPadding,
          })}
        >
          <EventItemHeader event={event} {...(showViewLink && { onClick: openEventDetails })} />
          <EventItemBody
            event={event}
            showDescription={showDescription}
            showViewLink={showViewLink}
            onDeleteSuccess={onDeleteSuccess}
            onSelectTab={onSelectTab}
          />
        </div>
      </>
    );
  }
);
